import Factory from '../factory';
import {Collection, Schema} from "@oilstone/rest-model-repository";

const schema = Factory.schema('full-bleed-hero-carousel');
const attributes = schema.getProp('attributes').getValue();
const item = new Schema();

item.prop('heading').setType(String).setValue('Heading');
item.prop('btnText').setType(String).setValue('Find out more');
item.prop('imgSrc').setType(String).setValue('image-placeholder-square.svg');

attributes.prop('items').setType(Collection).setValue(new Collection(item));

export default schema;
